import React from 'react'
import { useFormStepContext } from 'components/TasksV2/TaskCreation/FormStepContext'
import { AIStepType, useAILoadingContext } from '../AIFormStepContext'
import AIOnboardingStep from '../components/AIOnboardingStep'
import AISettingsStep from '../components/AISettingsStep'
import AISubtaskStep from '../components/AISubtaskStep'
import { AIPromptWorkspace } from '../components/AIPromptWorkspace'
import { AIGenerationProgress } from '../components/AIGenerationProgress'
import { SlideInPanel, useStepDirection } from 'components/TasksV2/UI/SlideInPanel'
import styles from './styles.module.css'

export function Content({
  onReset,
  headerSlot,
  onPromptReadyChange,
}: {
  onReset: () => void
  headerSlot: HTMLDivElement | null
  onPromptReadyChange: (ready: boolean) => void
}) {
  const { stepStack } = useFormStepContext()
  const { isGenerating, generationComplete } = useAILoadingContext()
  const step = stepStack[stepStack.length - 1]
  const prompt = step === AIStepType.AI_PROMPT || step === AIStepType.AI_PROMPT_GENERATOR
  // The helper is an internal right-panel view, not a transition of the whole workspace.
  const workspaceDepth = stepStack.filter((item) => item !== AIStepType.AI_PROMPT_GENERATOR).length
  const { direction, hasNavigated } = useStepDirection(workspaceDepth)

  return (
    <SlideInPanel key={prompt ? 'prompt-workspace' : step} direction={direction} isEnabled={hasNavigated} grow>
      {step === AIStepType.AI_ONBOARDING ? (
        <AIOnboardingStep />
      ) : prompt ? (
        <AIPromptWorkspace onReset={onReset} onPromptReadyChange={onPromptReadyChange} />
      ) : step === AIStepType.AI_SETTINGS ? (
        <AISettingsStep headerSlot={headerSlot} />
      ) : isGenerating ? (
        <AIGenerationProgress complete={generationComplete} />
      ) : (
        <div className={styles.preview}>
          <AISubtaskStep />
        </div>
      )}
    </SlideInPanel>
  )
}
